import { useIsShiftPostingRedesignEnabled } from '@src/helpers/shiftPostingRedesign'

export const UpdateShiftPostingRedesignFlag = () => {
  useIsShiftPostingRedesignEnabled()
  return null
}
